module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-form-login"
  }, [_c('div', {
    staticClass: "title title-form title-info text-center"
  }, [(!_vm.forgot) ? [_c('strong', [_vm._v("LOGIN")])] : [_vm._v("RECUPERAR "), _c('strong', [_vm._v("SENHA")])]], 2), _vm._v(" "), (_vm.forgot) ? _c('div', {
    staticClass: "subtitle"
  }, [_c('div', {
    staticClass: "space-10"
  }), _vm._v(" "), [_vm._v("Informe o seu e-mail cadastrado para recuperar a senha.")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), (!_vm.forgot) ? _c('div', {
    staticClass: "form-sign-in"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin()
      }
    }
  }, [_c('input-email', {
    attrs: {
      "placeholder": "E-mail",
      "name": "email",
      "disabled": _vm.loading,
      "error": _vm.errors.email
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('input-password', {
    attrs: {
      "placeholder": "Senha",
      "name": "password",
      "disabled": _vm.loading,
      "error": _vm.errors.password
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "space-15"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "btn btn-info bold",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('span', [_vm._v("ENTRANDO "), _c('i', {
    staticClass: "fa fa-fw fa-lg fa-spinner fa-spin"
  })]) : _c('span', [_vm._v("ENTRAR")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.swap('forgot')
      }
    }
  }, [_vm._v("Esqueceu sua senha?")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.forgot && !_vm.forgotSent) ? _c('div', {
    staticClass: "form-forgot-password"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.forgotPassword()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('input-email', {
    attrs: {
      "placeholder": "E-mail",
      "name": "email",
      "error": _vm.errors.email
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "btn btn-purple bold",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('span', [_vm._v("Aguarde "), _c('i', {
    staticClass: "fa fa-fw fa-lg fa-spinner fa-spin"
  })]) : _c('span', [_vm._v("Recuperar senha")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.swap('login')
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e(), _vm._v(" "), (_vm.forgotSent) ? _c('div', {
    staticClass: "text-center"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', [_c('h4', [_vm._v("Solicitação recebida!")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.forgotMessage))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.modalOpened) ? _c('modal-bootstrap', {
    attrs: {
      "title": "Temos de uso e políticas de privacidade",
      "footer": "",
      "auto-height": _vm.auto,
      "show": _vm.modalOpened
    },
    on: {
      "close": _vm.cancelLogin
    }
  }, [_vm._v("\n        A política de privacidade e/ou os termos de uso foram atualizados,\n        para continuar você precisa ler e aceitar os novos\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'use_terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("termos de uso")]), _vm._v(" e as\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy_policy'
      },
      "target": "_blank"
    }
  }, [_vm._v("políticas de privacidade")]), _vm._v(".\n    "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger white",
    on: {
      "click": _vm.cancelLogin
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.acceptTerms
    }
  }, [_vm._v("Aceitar")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b62ca72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormLogin.vue
// module id = 310
// module chunks = 18